/*

    Module: jv.req.search.url-redirect.service
    Service: jvReqSearchUrlRedirectService

    Used to set search parameters and redirect to requisition search.

    This is a singleton object.

    Usage:

        jvReqSearchUrlRedirectService.setDepartmentIds('BCV9Vfwl');
        jvReqSearchUrlRedirectService.AwaitingApproval('true');
        jvReqSearchUrlRedirectService.redirect();
 */
require('../../candidates/search/jv.search.serializer.service');

angular.module('jv.req.search.url-redirect.service', [
    'jv.search.serializer.service'
])
.service('jvReqSearchUrlRedirectService', [
    'jvSearchSerializer', '$window', '$filter',
    function(jvSearchSerializer, $window, $filter) {
        var data = {};
        var dateFilter = $filter('date');
        var saveFormat = 'yyyy-MM-dd';

        var setDateHelper = function(data, name, start, end) {
            data[name] = {
                to: dateFilter(end, saveFormat),
                from: dateFilter(start, saveFormat),
                type: 'custom'
            };
        };

        this.setMaxResults = function(count) {
            data.maxResults = count;
        };

        this.setSortBy = function(sortBy) {
            data.sortBy = sortBy;
        };

        this.setPostingType = function(postingType) {
            (data.postingType = data.postingType || []).push(postingType);
        };

        //Has to be boolean.
        this.setAwaitingApproval = function(awaitingApproval) {
            data.awaitingApproval = awaitingApproval;
        };

        this.setCategory = function(categoryId) {
            (data.categoryIds = data.categoryIds || []).push(categoryId);
        };

        this.setCompany = function(subsidiaryId) {
            (data.subsidiaryId = data.subsidiaryId || []).push(subsidiaryId);
        };

        this.setHiringManagers = function(hiringManagerId) {
            (data.hiringManagerIds = data.hiringManagerIds || []).push(hiringManagerId);
        };

        this.setRecruiters = function(recruiterId) {
            (data.recruiterIds = data.recruiterIds || []).push(recruiterId);
        };

        this.setDepartment = function(departmentId) {
            (data.departmentIds = data.departmentIds || []).push(departmentId);
        };

        this.setRegion = function(regionId) {
            (data.regionIds = data.regionIds || []).push(regionId);
        };

        this.setJobLocation = function(jobLocationId) {
            (data.locationIds = data.locationIds || []).push(jobLocationId);
        };

        this.setJobType = function(requisitionTypeId) {
            (data.typeIds = data.typeIds || []).push(requisitionTypeId);
        };

        this.setJobStateIds = function(jobStateId) {
            (data.jobStateValue = data.jobStateValue || []).push(jobStateId);
        };

        this.setQuery = function(query) {
            data.query = [];
            data.query.push(query);
        };

        this.setCreatedDate = function(start, end) {
            setDateHelper(data, 'createdDate', start, end);
        };

        this.setClosedDate = function(start, end) {
            setDateHelper(data, 'closedDate', start, end);
        };

        this.setFilledDate = function(start, end) {
            setDateHelper(data, 'filledDate', start, end);
        };

        this.setOpenDate = function(start, end) {
            setDateHelper(data, 'openDate', start, end);
        };

        this.reset = function() {
            data = {};
        };

        this.getUrl = function() {
            var url = $window.jvUrls.jhire + '/modules/requisitions/list.html#/q/';
            url += this.getEncodedData();
            return url;
        };

        this.getEncodedData = function() {
            return jvSearchSerializer.serialize(data);
        };

        this.redirect = function() {
            $window.location = this.getUrl();
        };
    }
]);
